import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';


const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement).render(<App />);

setTimeout(() => {
  document.dispatchEvent(new Event('custom-render-trigger'));
}, 1000);

serviceWorker.unregister();

reportWebVitals();